import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ListResponse} from './list-response';
import {ProductModel} from './product-model';
import {UpdateProductRequestModel} from './update-product-request-model';
import {CreateProductRequestModel} from './create-product-request-model';

@Injectable({
  providedIn: 'root'
})
export class ProductsService {
  constructor(private httpClient: HttpClient) { }

  public get(organizationId: string, categoryId: string): Observable<ListResponse<ProductModel>> {
    return this.httpClient.get<ListResponse<ProductModel>>(
      `/api/organizations/${organizationId}/products?categoryId=${categoryId}`);
  }

  public getOne(organizationId: string, itemId: string): Observable<ProductModel> {
    return this.httpClient.get<ProductModel>(
      `/api/organizations/${organizationId}/products/${itemId}`);
  }

  public activate(organizationId: string, productId: string): Observable<object> {
    return this.httpClient.post(`/api/organizations/${organizationId}/products/${productId}/activate`, null);
  }

  public deactivate(organizationId: string, productId: string): Observable<object> {
    return this.httpClient.post(`/api/organizations/${organizationId}/products/${productId}/deactivate`, null);
  }

  public create(organizationId: string, request: CreateProductRequestModel): Observable<ProductModel> {
    return this.httpClient.post<ProductModel>(`/api/organizations/${organizationId}/products`, request);
  }

  public update(organizationId: string, productId: string, request: UpdateProductRequestModel): Observable<ProductModel> {
    return this.httpClient.put<ProductModel>(`/api/organizations/${organizationId}/products/${productId}`, request);
  }
}
